module.exports = __webpack_public_path__ + "static/media/team.87470935.png";